import React from "react";
import { Stack } from "react-bootstrap";
import { TIMING_LIST_ITEM } from "../TimingList.renderer";
import { ITimingListProps } from "../TimingList.types";
import { toCSSODateString } from "../../../../../shared/utils/data.utils";
import { TimingLabel } from "../../../../../shared/enums/labels.enums";

const CONSTRUCTION_TIMING_STACK: React.FC<ITimingListProps> = (
  props: ITimingListProps
) => {
  const { timing } = props;

  return (
    <Stack data-testid="timing-construction-stack">
      <TIMING_LIST_ITEM
        label={TimingLabel.EARLIEST_START_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.scheduledStart ?? null
        )}
      />
      <TIMING_LIST_ITEM
        label={TimingLabel.PROJECTED_END_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.projectedEndDate ?? null
        )}
      />
    </Stack>
  );
};

export default CONSTRUCTION_TIMING_STACK;
